// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ToolIcon = /* @__PURE__ */ createIcon(
  'tool',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M20.56 8.44q0-.283-.03-.556L18.9 9.516c-.187.186-.369.369-.535.51a2 2 0 0 1-.686.402 2 2 0 0 1-1.237 0 2 2 0 0 1-.686-.403c-.166-.14-.347-.323-.533-.51l-.738-.737c-.186-.186-.37-.368-.51-.534a2 2 0 0 1-.402-.686 2 2 0 0 1 0-1.237c.094-.29.253-.511.402-.686.14-.166.324-.348.51-.534l1.63-1.631a5 5 0 0 0-5.413 6.158c.058.236.108.443.142.61.03.153.068.364.053.583-.02.299-.082.518-.22.784-.16.31-.446.578-.661.793l-6.248 6.249a1.122 1.122 0 0 0 1.586 1.585l6.248-6.248c.215-.215.483-.5.793-.66l.193-.09c.188-.077.367-.115.59-.13l.164-.003c.159.005.306.032.42.055.167.034.374.084.61.142q.571.14 1.189.142a5 5 0 0 0 5-5m2 0a7 7 0 0 1-8.66 6.801c-.254-.061-.414-.1-.53-.124l-.055-.01-.012.011a9 9 0 0 0-.287.28l-6.248 6.249a3.121 3.121 0 0 1-4.414-4.415l6.248-6.248c.143-.143.225-.225.28-.287l.01-.012-.008-.054c-.024-.117-.063-.277-.124-.53a7 7 0 0 1 9.683-8.043 1 1 0 0 1 .294 1.619L15.9 6.516c-.21.21-.324.325-.4.414l-.008.01q.004.003.008.01c.076.088.19.204.4.413l.737.738c.21.21.325.324.414.4l.01.008.01-.008c.09-.076.205-.19.414-.4l2.838-2.838.092-.081a1 1 0 0 1 1.526.376c.399.88.62 1.856.62 2.881',
      },
    ],
  ]
);
